import { ActeForList } from '../../../model/Acte'
import styles from './ActeListItem.module.scss'

export const ActeListItem = ({ item }: { item: ActeForList }) => (
  <div className={styles.container}>
    <span className={styles.title}>{`${item.id} : ${item.libelle}`}</span>
  </div>
)
